import React from 'react';
import { Modal } from 'react-bootstrap';


function Video360(props) {
    return (
        <div>
            <Modal show={props.show} fullscreen={true} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>360° Video</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe width="100%" height="100%" src={props.video + "?autoplay=1"} title="360° Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                </Modal.Body>
            </Modal>
            
        </div>
    );
}

export default Video360;